<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}">
    <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
    <div :class="{
      speechBubbleTailedLeft:
        $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy,
      speechBubbleNonTailedLeft:
        $store.state.session.user.UserID !== message.From && message.continueFromSameBuddy,
      speechBubbleTailedRight:
        $store.state.session.user.UserID === message.From && !message.continueFromSameBuddy,
      speechBubbleNonTailedRight:
        $store.state.session.user.UserID === message.From && message.continueFromSameBuddy
    }"
    >
      <ForwardedMessageRow v-if="message.isForwarded" />
      <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />

      <div class="senderName" :style="{ color: userColor(message.From) }" v-if="
        message.isGroup === true && $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy
      "
      >
        {{ getUserNameDisplay(message.From) }}
      </div>

      <MessageMenuDropDown :message="message" />

      <div class="contactBody">
        <div class="contactInfo">
          <img class="contactPhoto" src="@/assets/images/nophoto.png">
          <div class="contactData">
            <div>{{ contactData.display_name }}</div>
            <div v-for="(homePhone,homeIndex) in contactData.phones_home"
                 :key="contactData.display_name + homeIndex + 'hp'"
            >
              ev: {{ homePhone }}
            </div>
            <div v-for="(mobilePhone, mobileIndex) in contactData.phones_mobile"
                 :key="contactData.display_name + mobileIndex + 'mp'"
            >
              cep: {{ mobilePhone }}
            </div>
            <div v-for="(workPhone,workIndex) in contactData.phones_work" :key="contactData.display_name + workIndex + 'wp'">
              iş: {{ workPhone }}
            </div>
          </div>
        </div>
        <div class="actionRow">
          <div @click="downloadVCard">
            Kaydet
          </div>
        </div>
      </div>

      <MessageBalloonInfoRow :message="message" />
    </div>

    <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
  </div>
</span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'

var vCardsJS = require('vcards-js')
var FileSaver = require('file-saver')

export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown
  },

  mixins: [messageMixin],

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  computed: {
    contactData () {
      return JSON.parse(this.message.Body)
    }
  },

  methods: {
    downloadVCard () {
      let vCard = vCardsJS()

      vCard.firstName = this.contactData.display_name
      vCard.middleName = ''
      vCard.lastName = ''
      vCard.homePhone = this.contactData.phones_home
      vCard.workPhone = this.contactData.phones_work
      vCard.cellPhone = this.contactData.phones_mobile

      let fileName = vCard.firstName.toLocaleLowerCase() + ' ' + vCard.lastName.toLocaleLowerCase() + '.vcf'

      let blob = new Blob([vCard.getFormattedString()], {
        type: 'text/plain;charset=utf-8'
      })
      FileSaver.saveAs(blob, fileName)
    }
  },

  mounted () {}
}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .contactBody {
    width: 300px;
    display: flex;
    flex-direction: column;
  }

  .contactInfo {
    display: flex;
    align-items: center;

    &>.contactPhoto {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }

    &>.contactData {
      margin-left: 20px;

      &>div:first-child {
        font-weight: 700;
      }
    }
  }

  .actionRow {
    display: flex;
    margin: 10px;
    margin-bottom: 0px;

    &>div {
      width: 100%;
      text-align: center;
      padding: 10px;
      margin: 1px;
      background-color: rgb(245, 245, 245);
      cursor: pointer;
    }
  }

</style>
